module.exports = __webpack_public_path__ + "static/img/tabs05.09f8a009.png";